import { render, staticRenderFns } from "./ChannelsResult.vue?vue&type=template&id=aa2b9c30&"
import script from "./ChannelsResult.vue?vue&type=script&lang=js&"
export * from "./ChannelsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports